import _ from 'lodash'

const idsFromString = str => {
  let ids = []
  if (_.isEmpty(str)) {
    return ids
  }
  if (str.indexOf('(') === 0) {
    ids = _.split(str.substring(1, str.length - 1), ')(')
  } else {
    ids = _.split(str, ',')
  }
  ids = _.map(ids, _.parseInt)
  _.remove(ids, id => {
    return _.isNaN(id)
  })
  return ids
}

const idFromString = str => {
  let id = 0
  if (_.isEmpty(str)) {
    return id
  }
  if (str.indexOf('(') === 0) {
    id = _.parseInt(str.substring(1, str.length - 1))
  }
  if (_.isNaN(id)) {
    id = 0
  }
  return id
}

export default {
  idsFromString,
  idFromString
}
